module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "add-contact"
  }, [(_vm.item.isAdd) ? _c('el-button', {
    staticClass: "add-contat-btn",
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addContact()
      }
    }
  }, [_vm._v("添加联系人")]) : _vm._e(), _vm._v(" "), (_vm.contactArrayCopy.length) ? _c('div', {
    staticClass: "contact-box"
  }, _vm._l((_vm.contactArrayCopy), function(contact, index) {
    return _c('div', {
      key: contact.key,
      staticClass: "contact-item"
    }, [_c('div', {
      staticClass: "contact-info"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(contact.name))]), _vm._v(" "), _c('span', {
      staticClass: "phone"
    }, [_vm._v(_vm._s(contact.phone))])]), _vm._v(" "), _c('div', {
      staticClass: "contact-btn"
    }, [(_vm.item.isEdit || contact.id === '0') ? _c('i', {
      staticClass: "el-icon-edit-outline",
      on: {
        "click": function($event) {
          _vm.addContact(index)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.item.isDel || contact.id === '0') ? _c('i', {
      staticClass: "el-icon-delete",
      on: {
        "click": function($event) {
          _vm.deleteContact(index)
        }
      }
    }) : _vm._e()])])
  })) : (!_vm.item.isAdd) ? _c('div', [_vm._v("无")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8e157320","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fieldtype/add-contact.vue
// module id = 1317
// module chunks = 82